import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-green-dark relative overflow-hidden" data-id="element-91">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-green-emerald/20 via-green-dark to-green-dark pointer-events-none" data-id="element-92"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-93">
        <div className="text-center mb-16" data-id="element-94">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-white" data-id="element-95">
            El próximo lunes podés seguir improvisando...
            <br data-id="element-96" />
            <span className="text-green-veryLight" data-id="element-97">
              O podés entrar al aula con todo listo desde hoy.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white/5 p-8 rounded-2xl border border-white/10" data-id="element-98">
            {['Sin más noches buscando cómo explicar conceptos biológicos complejos en un lenguaje que tus alumnos entiendan', 'Sin más clases armadas de apuro con material que no conecta con la realidad de tus estudiantes latinoamericanos', 'Sin más alumnos desconectados que no entienden para qué les sirve estudiar el cuerpo humano', 'Sin más fines de semana perdidos construyendo actividades y evaluaciones desde cero', 'Sin más silencios incómodos frente a preguntas técnicas que te ponen en aprietos'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-99">
                <span className="text-green-light mt-1" data-id="element-100">▸</span>
                <span className="text-gray-200" data-id="element-101">{item}</span>
              </div>)}
          </div>

          <p className="text-xl text-white mb-2" data-id="element-102">
            El Mega Pack Ciencias de la Salud en el Aula no te convierte en
            mejor docente.
          </p>
          <p className="text-2xl font-bold text-green-light mb-6" data-id="element-103">
            Vos ya sos un buen docente.
          </p>
          <p className="text-xl text-gray-300 mb-16" data-id="element-104">
            Lo que hace el Mega Pack es darte el tiempo y las herramientas para
            que eso se note en cada clase.
          </p>
        </div>

        <div className="bg-white border-2 border-gold/30 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(20,83,45,0.2)]" data-id="element-105">
          <h3 className="text-2xl font-bold text-green-dark mb-6 text-center border-b border-green-emerald/15 pb-6" data-id="element-106">
            Todo lo que incluye:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-107">
            {['Tomo 1 — Biología y Fisiología Humana', 'Tomo 2 — Nutrición y Metabolismo Energético', 'Tomo 3 — Sistema de Control e Inmunidad', 'Tomo 4 — Salud Sexual, Prevención y Cuidado', 'Bono 1 — Paquete de Actividades Prácticas', 'Bono 2 — Paquete de Evaluaciones 360 con Clave', 'Bono 3 — Guía de Proyectos y Ferias Científicas', 'Bono 4 — Glosario Técnico Superior', 'Garantía de 7 días sin preguntas', 'Pago en tu moneda local', 'Acceso inmediato', 'Formato PDF listo para usar'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-108">
                <Check size={18} className="text-green-emerald shrink-0" data-id="element-109" />
                <span className="text-sm text-ink-muted" data-id="element-110">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-111">
            <div className="mb-8 p-6 bg-green-veryLight rounded-xl border border-green-emerald/20 italic text-ink-muted text-lg" data-id="element-112">
              "El mejor momento para tener este material era al inicio del año.
              <br data-id="element-113" />
              <span className="text-green-emerald font-bold not-italic" data-id="element-114">
                El segundo mejor momento es hoy.
              </span>
              "
            </div>

            <p className="text-xl font-serif font-bold text-green-dark mb-2" data-id="element-115">
              📚 Mega Pack Ciencias de la Salud en el Aula
            </p>
            <p className="text-sm text-ink-muted mb-8" data-id="element-116">
              Hecho por especialistas, para docentes de toda América Latina.
            </p>

            <Button href="#pricing" className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-117">
              🟡 QUIERO MI MEGA PACK AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-ink-muted" data-id="element-118">
              <span data-id="element-119">✅ Garantía de 7 días</span>
              <span data-id="element-120">✅ Pago seguro</span>
              <span data-id="element-121">✅ Acceso inmediato</span>
              <span data-id="element-122">✅ Pagás en tu moneda local</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}